
let loc = window.location.href
let lang = 'cz'
if (loc.includes('https://www.bola.cz')) lang = 'cz'
if (loc.includes('https://www.bola.sk')) lang = 'sk'
if (loc.includes('https://www.bolasystems.com')) lang = 'en'
if (loc.includes('http://localhost:3000/')) lang = 'en'
if (loc.includes('https://www.bolasystems.fr')) lang = 'fr'
if (loc.includes('https://www.bolasystems.de')) lang = 'de'
if (loc.includes('https://www.bolasystems.nl')) lang = 'nl'
if (loc.includes('https://www.bolasystems.it')) lang = 'it'
if (loc.includes('https://www.bolasystems.com.ua')) lang = 'ua'

export const language=lang